import { useTranslate } from "@refinedev/core";
import { Trans } from "react-i18next";
import { HeadsetIcon } from "@phosphor-icons/react";
import styled from "styled-components";
import { radius } from "@libertify/ui";

const BOOK_A_CALL_URL = "https://meetings.hubspot.com/alex-liberty";

export const NeedHelpCard = () => {
  const t = useTranslate();

  return (
    <StyledCard>
      <StyledIconWrap>
        <HeadsetIcon size={24} weight="bold" color="#14b8a6" fill="#000000" />
      </StyledIconWrap>
      <StyledContent>
        <StyledTitle>{t("components.needHelpCard.title")}</StyledTitle>
        <StyledDescription>
          <Trans
            components={{
              a: (
                <StyledLink
                  href={BOOK_A_CALL_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
            }}
          >
            {t("components.needHelpCard.description")}
          </Trans>
        </StyledDescription>
      </StyledContent>
    </StyledCard>
  );
};

const StyledCard = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  border-radius: ${radius.box}px;
  border: 1px solid #6f747f;
  background: #fff;
  padding: 24px;
  margin-top: 48px;
`;

const StyledIconWrap = styled.div`
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ccfbf1;
  border-radius: 10px;
`;

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

const StyledTitle = styled.p`
  font-size: 16px;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 600;
  color: #090e19;
  margin: 0;
  letter-spacing: -0.16px;
`;

const StyledDescription = styled.p`
  font-size: 16px;
  font-family: "Inter", sans-serif;
  color: #090e19;
  line-height: 1.5;
  margin: 0;
`;

const StyledLink = styled.a`
  font-size: 16px;
  color: #14b8a6;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-decoration: underline solid;
  line-height: normal;
  letter-spacing: -0.16px;

  &:hover {
    color: #0d9488;
  }
`;
